// src/hooks/useConfirm.js
import { useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export const useConfirm = () => {
  const [open, setOpen] = useState(false);
  const [resolve, setResolve] = useState(null);
  const [message, setMessage] = useState('');

  const confirm = useCallback((message) => {
    setMessage(message);
    setOpen(true);
    return new Promise((res) => {
      setResolve(() => res);
    });
  }, []);

  const handleClose = (value) => {
    setOpen(false);
    if (resolve) {
      resolve(value);
    }
  };

  const ConfirmDialog = () => (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { confirm, ConfirmDialog };
};